import type { Maybe } from '@seek/ca-myprofile-utils';
import { useTranslations } from '@vocab/react';
import { Text, IconCritical } from 'braid-design-system';
import React from 'react';

import { LoadingItem } from 'src/components/LoadingBlock/LoadingBlock';
import type { VisibilityLevel } from 'src/types/graphql';

import { useGetProfileVisibility } from '../data';

import translations from './.vocab';

const mappedProfileVisibilityLevelTone = (
  profileVisibilityLevel: Maybe<VisibilityLevel>,
) => {
  switch (profileVisibilityLevel) {
    case null:
      return 'critical';
    default:
      return 'neutral';
  }
};

interface Props {
  loading?: boolean;
}

export const ProfileVisibilityStatus = ({ loading }: Props) => {
  const { t } = useTranslations(translations);
  const { profileVisibilityLevel } = useGetProfileVisibility();

  const profileVisibilityLevelText = {
    Hidden: t('Not searchable by employers'),
    Standard: t('Searchable by employers'),
    Limited: t('Searchable by employers'),
  };

  const id = `profile-visibility-status-${
    profileVisibilityLevel ? profileVisibilityLevel.toLowerCase() : 'not-set'
  }-txt`;

  return loading ? (
    <LoadingItem type="text" size="standard" width="large" />
  ) : (
    <Text
      id={id}
      data={{ automation: id }}
      {...(profileVisibilityLevel === null && { icon: <IconCritical /> })}
      tone={mappedProfileVisibilityLevelTone(profileVisibilityLevel)}
    >
      {profileVisibilityLevel
        ? profileVisibilityLevelText[profileVisibilityLevel]
        : t('Searchable by employers not set')}
    </Text>
  );
};
